import { render, staticRenderFns } from "./ModalListaCorreos.vue?vue&type=template&id=9c2dac32&scoped=true&"
import script from "./ModalListaCorreos.vue?vue&type=script&lang=js&"
export * from "./ModalListaCorreos.vue?vue&type=script&lang=js&"
import style0 from "./ModalListaCorreos.vue?vue&type=style&index=0&id=9c2dac32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2dac32",
  null
  
)

export default component.exports